import React, { Component } from 'react';
import SideBar from '../../../components/SideBar/SideBar';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  Button,
  Col,
  Row,
  Alert,
} from 'react-bootstrap';
import { BlocklyFullXml } from '../constants/BatchBlocklyXml';
import * as Blockly from 'blockly/core';
import 'blockly/blocks';
import { javascriptGenerator } from 'blockly/javascript';
import './LogicEditor.css';
import * as En from 'blockly/msg/en';
import addCustomBlocks from '../utils/addCustomBlocks';
import restoreCodeFromXml from '../utils/restoreCodeFromXml';
import logger from '../../../utils/logger';
Blockly.setLocale(En);

@inject('batchStore', 'sidebarStore', 'batchLogicStore')
@observer
class LogicEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      codeVisible: false,
      error: null,
    };
  }

  componentDidMount() {
    this.mounted = true;

    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(BlocklyFullXml, 'text/xml');
      const toolboxXml = xmlDoc.documentElement;

      this.workspace = Blockly.inject('blockly', {
        toolbox: toolboxXml,
        sounds: {
          enabled: false,
        },
        move: {
          scrollbars: true,
          drag: true,
          wheel: true,
        },
      });

      addCustomBlocks();
      this.loadCode();
      this.workspace.addChangeListener(this.update);
    } catch (error) {
      console.error('Error initializing Blockly:', error);
      this.setState({ error: error.message });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.workspace.removeChangeListener(this.update);
  }

  loadCode = () => {
    const { batchLogicStore } = this.props;

    // If code is already fetched, restore it
    if (batchLogicStore.code) {
      this.restoreCode();
      return;
    }

    batchLogicStore.getCode()
      .then(() => {
        if (batchLogicStore.code && this.mounted) {
          this.loadCode();
        }
      })
      .catch(e => {
        if (this.mounted) {
          this.setState({
            error: `Couldn't fetch data: ${e.message}`,
          });
        }
      });
  };

  restoreCode = () => {
    const { batchLogicStore } = this.props;
    try {
      restoreCodeFromXml(batchLogicStore.code, this.workspace);
    } catch (error) {
      logger.error('Error loading workspace:', error);
      this.setState({
        error: `Error loading workspace: ${error.message}`,
      });
    }
  };

  backupCode = () => {
    const { batchLogicStore } = this.props;
    const xml = Blockly.Xml.workspaceToDom(this.workspace);
    const code = Blockly.Xml.domToText(xml);

    batchLogicStore.saveCode(code);
    this.props.sidebarStore.onToggle(null);
  };

  update = () => {
    try {
      this.props.batchStore.code = javascriptGenerator.workspaceToCode(this.workspace);
      this.setState({ error: null });
    } catch (error) {
      this.setState({
        error: 'There was an error generating the code. Please check your blocks. If this error persists, please contact support.',
      });
    }
  };

  toggleCode = () => {
    this.setState({
      codeVisible: !this.state.codeVisible,
    });
  };

  renderEditor = () => {
    const { error, codeVisible } = this.state;
    const { code } = this.props.batchStore;

    return (
      <div className="logic-editor">
        <Row>
          <Col sm={12}>
            <div id="blockly"/>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Button onClick={this.toggleCode}><i className="fa fa-code"/> Code</Button>
          </Col>
          <Col sm={6} className="text-right">
            <Button className="btn btn-primary" onClick={this.backupCode}>Save</Button>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            {!!error && <Alert bsStyle="danger">{error}</Alert>}
            {codeVisible && <pre>{code}</pre>}
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    return (
      <SideBar type="editor" icon={'fa-code'} title={'Batch Logic Editor'}>
        {this.renderEditor()}
      </SideBar>
    );
  }
}

export default LogicEditor;
